<template>
  <div class="container">
    <div class="nav-img">
      <img v-if="url.indexOf('shian360.com') != -1" src="@/assets/stlogo.png" />
      <img v-else src="@/assets/cqqlogo.png" />
      <!-- <img src="@/assets/cqqlogo.png" /> -->
      <div class="nav-btn">
        <el-button type="primary" @click="login()">没有账号，注册</el-button>
        <el-button type="primary" @click="openHonme()">回到首页</el-button>
      </div>
    </div>
    <div class="form-con">
      <div class="release-title">登录</div>
      <el-row>
        <el-col :span="16">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="ruleForm.username"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="ruleForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { proModuleApi } from '@/api/home'
export default {
  name: 'login',
  data() {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入11位数的正确手机号码', trigger: 'blur' },
          { message: '长度为11位数的正确手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入不少于3位的密码', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15个字符', trigger: 'blur' }
        ]
      },
      url: ''
    }
  },
  created() {
    this.url = window.location.hostname
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {}
          params.username = this.ruleForm.username
          params.password = this.ruleForm.password
          proModuleApi
            .loginInfo(params)
            .then(res => {
              if (res.msg == 'success') {
                sessionStorage.setItem('token', res.data.token)
                this.$router.push({ path: '/index' })
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openHonme() {
      this.$router.push({ path: '/index' })
    },
    login() {
      this.$router.push({ path: '/register' })
    }
  }
}
</script>
<style scoped>
.nav-img {
  width: 1200px;
  margin: 0 auto;
}
.nav-img img {
  width: 400px;
  height: 300px;
  margin-top: -80px;
}
.logo-title {
  /* margin-top: -150px; */
  color: #fc6720;
  float: right;
  position: absolute;
  left: 450px;
  top: 60px;
  font-size: 22px;
}
.form-con {
  width: 1200px;
  margin: 0 auto;
  margin-top: -80px;
}
.release-title {
  background-color: #107a53;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  padding-left: 30px;
  margin-bottom: 20px;
}
.el-button--primary {
  background-color: #107a53;
  border: none;
}
.el-button--primary:hover {
  background-color: #fc6720;
}
.nav-btn {
  float: right;
  position: absolute;
  top: 50px;
  right: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue